import React, { useState } from "react"
import classNames from "classnames"

import { getData } from "./data"
import styles from "./styles.module.scss"
import FeaturesTable from "../../../components/_V2/prices/FeaturesTable"
import ChevronTop from "../../../assets/_V2/svg/ChevronTop"
import {useLocalizationContext} from "../../../localization/useLocalizationContext";


interface Props {
	className?: string
	mobileSelectedTariff: string
	notShowButton?: boolean
}

export default function DetailFeatures(props: Props) {
	const localizationContext = useLocalizationContext();

	const [isShowFeatures, setIsShowFeatures] = useState(props.notShowButton)

	const onClickBtn = () => {
		setIsShowFeatures(!isShowFeatures)
	}

	return (
		<section className={classNames(props.className, styles.detailFeatures)}>
			{!props.notShowButton && (
				<button
				className={classNames(styles.detailFeatures__btn, {
					[styles.detailFeatures__btnClosed]: !isShowFeatures,
				})}
				onClick={onClickBtn}
			>
				Подробнее о тарифах
				<ChevronTop />
			</button>
			)}

			{isShowFeatures && (
				<div className={styles.detailFeatures__wrapper}>
					{getData(localizationContext.locale).map(featuresTable => (
						<FeaturesTable
							isOpened={true}
							mobileSelectedTariff={props.mobileSelectedTariff}
							setModulesCost={props.setModulesCost}
							data={featuresTable}
						/>
					))}
				</div>
			)}
		</section>
	)
}
